import axios from 'axios'

export let config = {
  apiBasePath: '/backend/',
  meBasePath: '/'
}

let instance = axios.create({
  baseURL: config.meBasePath,
  headers: {
    'Access-Control-Allow-Origin': '*'
  }
})

let meInstance = axios.create({
  baseURL: config.meBasePath
})

export default {
  instance,
  meInstance,
  DataState: {
    notStarted: 'notStarted',
    loading: 'loading',
    success: 'success',
    error: 'error'
  }
}
